var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHomeGrey = function SvgHomeGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.062,
    height: 42.307,
    viewBox: "0 0 43.062 42.307",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3198",
    "data-name": "Caminho 3198",
    d: "M69.167,1026.7l-19.078,19.8a.92.92,0,0,0,.659,1.559l4.464.015v17.65h10.2V1054.74a1.146,1.146,0,0,1,1.146-1.145H73.1a1.146,1.146,0,0,1,1.146,1.145v10.989h10.2v-17.65l4.464-.015a.92.92,0,0,0,.659-1.559l-19.078-19.8A.921.921,0,0,0,69.167,1026.7Z",
    transform: "translate(-48.299 -1024.922)",
    fill: "none",
    stroke: "#cecece",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home_grey.fcb10068.svg";
export { ForwardRef as ReactComponent };